
    module.exports = function(f1,f2){
        if(f1 == f2) return 0;
        if(f1 < f2) return -1;
        if(f1 > f2) return 1;
    };




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/internals/numberComparator.js
// module id = 3062
// module chunks = 15